import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ButtonsModule } from '../button/button.module';
import { IconModule } from '../icon/icon.module';
import { CalendarModule } from '../calendar/calendar.module';
import { DateRangePickerComponent } from './date-range-picker.component';
import { DateRangePickerTemplateComponent } from './date-range-picker.template.component';

@NgModule({
  imports: [
    ButtonsModule,
    CommonModule,
    FormsModule,
    IconModule,
    CalendarModule
  ],
  declarations: [
    DateRangePickerComponent,
    DateRangePickerTemplateComponent
  ],
  exports: [
    DateRangePickerComponent
  ],
})
export class DateRangePickerModule { }
